import { useIdleTimeout } from '@/service/useIdleTimeout';
import apiMain from '@/api/api-main'

export default async function auth({ next, router }) {
  const token = safeParse('token')
  const user = safeParse('user')
  // Phải có đủ cả token lẫn user: state Vuex auth khởi tạo từ localStorage['user'],
  // thiếu user mà vẫn cho đi tiếp thì các màn đọc state.auth.user.appUser sẽ lỗi null
  if (!token?.token || !user?.appUser) {
    localStorage.removeItem('user');
    localStorage.removeItem('token');
    return router.push({ name: 'login' });
  }
  else {
    useIdleTimeout(30 * 60 * 1000);
    await checkTokenTime(token.ExpireToken, token.refresh_token);
    return next();
  }
}

function safeParse(key) {
  try {
    return JSON.parse(localStorage.getItem(key));
  } catch {
    return null;
  }
}

async function checkTokenTime(time, refresh_token) {
  const targetDate = new Date(time);
  const currentDate = new Date();
  const timeDifference = targetDate - currentDate;
  const minutesDifference = Math.round(timeDifference / (1000 * 60));
  if (minutesDifference < 1) {
    try {
      const response = await apiMain.add(`Account/RefreshToken?refreshRequest=${refresh_token}`);
      if (response.data) {
        const currentDate = new Date();
        const expireTokenTime = new Date(currentDate.getTime() + 59 * 60 * 1000).toString();
        const jToken = { ExpireToken: expireTokenTime, token: response.data.token, refresh_token: response.data.refresh_token }
        localStorage.setItem('user', JSON.stringify(response.data));
        localStorage.setItem('token', JSON.stringify(jToken));
      }
    } catch (error) {
    }
  }

}